namespace RioERP.Reports {
    export interface OrderProductsForm {
        OrderId: Serenity.IntegerEditor;
        ProductId: Serenity.LookupEditor;
        Quantity: Serenity.IntegerEditor;
        Cost: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        DiscountAmt: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxableAmount: Serenity.DecimalEditor;
        SerialKey: Serenity.StringEditor;
        HasPendrive: Serenity.BooleanEditor;
        HasBooks: Serenity.BooleanEditor;
        HasCourier: Serenity.BooleanEditor;
        DownloadUrl1: Serenity.StringEditor;
        DownloadUrl2: Serenity.StringEditor;
        InvoiceCompanyId: Serenity.IntegerEditor;
        FranchiseeDiscountAmount: Serenity.DecimalEditor;
        FranchiseeDiscountValue: Serenity.DecimalEditor;
        EFranchiseeDiscountType: Serenity.IntegerEditor;
        EOpens: Serenity.IntegerEditor;
        EWatchTime: Serenity.IntegerEditor;
        EValidity: Serenity.IntegerEditor;
        EValidityType: Serenity.IntegerEditor;
        ValidTill: Serenity.DateEditor;
        TotalAllowedDuration: Serenity.IntegerEditor;
        AllowedDevices: Serenity.StringEditor;
        IsLive: Serenity.BooleanEditor;
        EAccessStatus: Serenity.IntegerEditor;
        IsTemplateSerialKey: Serenity.BooleanEditor;
        Note: Serenity.StringEditor;
        ESerialkeyStatus: Serenity.IntegerEditor;
        TaxAmount: Serenity.DecimalEditor;
    }

    export class OrderProductsForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.OrderProducts';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderProductsForm.init)  {
                OrderProductsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.StringEditor;
                var w4 = s.BooleanEditor;
                var w5 = s.DateEditor;

                Q.initFormType(OrderProductsForm, [
                    'OrderId', w0,
                    'ProductId', w1,
                    'Quantity', w0,
                    'Cost', w2,
                    'GrossAmount', w2,
                    'DiscountAmt', w2,
                    'NetAmount', w2,
                    'TaxableAmount', w2,
                    'SerialKey', w3,
                    'HasPendrive', w4,
                    'HasBooks', w4,
                    'HasCourier', w4,
                    'DownloadUrl1', w3,
                    'DownloadUrl2', w3,
                    'InvoiceCompanyId', w0,
                    'FranchiseeDiscountAmount', w2,
                    'FranchiseeDiscountValue', w2,
                    'EFranchiseeDiscountType', w0,
                    'EOpens', w0,
                    'EWatchTime', w0,
                    'EValidity', w0,
                    'EValidityType', w0,
                    'ValidTill', w5,
                    'TotalAllowedDuration', w0,
                    'AllowedDevices', w3,
                    'IsLive', w4,
                    'EAccessStatus', w0,
                    'IsTemplateSerialKey', w4,
                    'Note', w3,
                    'ESerialkeyStatus', w0,
                    'TaxAmount', w2
                ]);
            }
        }
    }
}
